if (!customElements.get('custom-pagination')) {
	class Pagination extends HTMLElement {
	  constructor() {
	    super();
	    this.initClickHandler();
	  }

	  initClickHandler() {
	    this.querySelector('a')?.addEventListener('click', function(e) {
	      e.preventDefault();
	      e.currentTarget.parentElement.handlePaginationClick();
	    });
	  }

	  handlePaginationClick() {
	    document.querySelector('collection-grid').getProduct();
	  }
	}
	customElements.define('custom-pagination', Pagination);
}

class CollectionGrid extends HTMLElement {
	constructor() {
		super();

		this.method = this ? this.getAttribute("data-method") : 0;
		this.loader = document.querySelector('#AjaxinatePagination');
		this.loading = false;
		this.init();
	}

	init() {
		if (this.method == 'scroll') {
			this.addScrollListener();
		}
		if(document.querySelector('#banner-collection')){
			this.insertBanner();
			this.insertSeparate();
		}
	}

	insertBanner() {
		const banner = document.querySelector('#banner-collection');
		if (!banner || document.querySelector('#banner-item')) {
			return;
		}
		let pos = document.querySelector('.metafield-banner-collection').getAttribute('data-row');
		banner.style.display = 'none';
		let grid = this.querySelector('#product-grid');
		let div = document.createElement('div');
		div.setAttribute('id', 'banner-item');
		div.innerHTML = banner.innerHTML;
		let self = this;
		let countItems = this.querySelectorAll('div.grid__item').length;
		for (var i = 0; i < countItems; i++) {
			if (countItems < pos*4 && i == (countItems - 1)) {
				self.insertAfter(div, this.querySelectorAll('div.grid__item')[i]);
			} else if(countItems >= pos*4 && i == (pos*4 - 1)) {
				self.insertAfter(div, this.querySelectorAll('div.grid__item')[i]);
			}
		}
	}

	insertAfter(newNode, existingNode) {
        existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    }
    insertSeparate(){
		let countItems = this.querySelectorAll('div.grid__item').length;
		let self = this;
		var div = document.createElement('div');
			div.setAttribute('class', 'border-item');
		for (var i = 1; i <= countItems; i++) {
			if (i % 4 == 0) {
				self.insertBefore(div.cloneNode(true), this.querySelectorAll('div.grid__item')[i]);
			}
		}
    }
	addScrollListener() {
		if (this.loader) {
			document.addEventListener("scroll", this.paginationInView.bind(this));
			window.addEventListener("resize", this.paginationInView.bind(this));
			window.addEventListener(
        "orientationchange",
        this.paginationInView.bind(this)
			);
		}
	}

	paginationInView() {
		var top = this.loader.getBoundingClientRect().top - 100;
		var bottom = this.loader.getBoundingClientRect().bottom + 100;
		if (top <= window.innerHeight && bottom >= 0 && !this.loading) {
			this.getProduct();
		}
	}

	getProduct() {
		this.nextPageLinkElement = this.loader.querySelector("a");
		this.loading = true;
		if (this.nextPageLinkElement) {
			this.nextPageLinkElement.innerHTML = 'Loading...';
			this.nextPageUrl = this.nextPageLinkElement.href;
			if (this.nextPageUrl) {
				fetch(this.nextPageUrl)
					.then((response) => response.text())
					.then((responseText) => {
						const html = responseText;
						this.insertAdjacentHTML('beforeEnd',
							new DOMParser()
								.parseFromString(html, "text/html")
								.querySelector("#product-grid").innerHTML)
						this.loader.innerHTML = 
							new DOMParser()
								.parseFromString(html, "text/html")
								.querySelector("#AjaxinatePagination").innerHTML;
            this.loader.initClickHandler();
						this.loading = false;
						this.init();

						if(document.querySelectorAll('.article-card-wrapper')){
						    document.querySelectorAll('.article-card-wrapper').forEach((item) => {
						    var contentEl = item.querySelector('[id^="article-card__content-"]');
						    var contentText = contentEl.innerText || contentEl.textContent;
						    var mins = Math.ceil(contentText.trim().split(/\s+/).length / 5 / 60);
						    var mTextLabel = 'Reading time:';
						    var mText = mins > 1 ? 'mins' : 'min';
						    if(item.querySelector('[id^="reading_time-"]')){
						    	item.querySelector('[id^="reading_time-"]').innerHTML = mTextLabel + ' ' + mins + ' ' + mText;
						    }
						  });
						}
					});
			}
		}
	}
}

customElements.define("collection-grid", CollectionGrid);